// blogPostsSet10.js - Artículos 146-150

export const blogPostsSet10 = [
  {
    id: 146,
    title: "¿El Plátano Engorda? Calorías, Azúcar y Cuándo Comerlo",
    seoTitle: "¿El Plátano Engorda? Verde o Maduro, y Sus Calorías",
    slug: "el-platano-engorda-calorias-cuando-comer",
    author: "Wayo Nutrition Team",
    date: "2026-01-31",
    readTime: "13 min",
    category: "Nutrición",
    image: "https://images.unsplash.com/photo-1571771894821-ce9b6c11b08e?w=1200",
    excerpt: "¿El plátano engorda o es un mito? Descubre cuántas calorías tiene, su índice glucémico, cuándo comerlo y cómo incluirlo en tu dieta sin subir de peso.",
    metaDescription: "Un plátano mediano son unas 105 kcal. Verde o maduro tiene casi las mismas calorías: cambia el azúcar y lo que sacia. Y el plátano macho, aparte.",
    keywords: ["plátano engorda", "calorías plátano", "banana calorías", "plátano azúcar", "cuándo comer plátano"],
    tags: ["plátano", "banana", "frutas", "calorías"],
    content: `
      <div class="blog-article-extended">
        <h2>El Plátano: ¿Amigo o Enemigo de Tu Dieta?</h2>
        <p>El plátano (o banana) es probablemente la fruta más controversial en el mundo de las dietas. Algunos lo evitan como la peste, asumiendo que "tiene demasiado azúcar" o "engorda". Otros lo comen sin preocupación.</p>

        <p>¿Cuál es la verdad? ¿El plátano engorda o es perfectamente saludable para incluir en una dieta de pérdida de peso?</p>

        <div class="info-box">
          <h3>⚡ La Respuesta Rápida</h3>
          <ul>
            <li>1 plátano mediano = ~105 calorías</li>
            <li>NO engorda más que otras frutas con calorías similares</li>
            <li>Es alto en potasio, fibra y nutrientes</li>
            <li>Mejor momento: pre o post-entrenamiento</li>
          </ul>
        </div>

        <h2>Calorías del Plátano Según Tamaño</h2>

        <table class="comparison-table">
          <thead>
            <tr>
              <th>Tamaño del Plátano</th>
              <th>Peso (sin piel)</th>
              <th>Calorías</th>
              <th>Azúcar</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td><strong>Extra pequeño (&lt;15 cm)</strong></td>
              <td>81g</td>
              <td>72 kcal</td>
              <td>10g</td>
            </tr>
            <tr>
              <td><strong>Pequeño (15-18 cm)</strong></td>
              <td>101g</td>
              <td>90 kcal</td>
              <td>12g</td>
            </tr>
            <tr>
              <td><strong>Mediano (18-20 cm)</strong></td>
              <td>118g</td>
              <td>105 kcal</td>
              <td>14g</td>
            </tr>
            <tr>
              <td><strong>Grande (20-23 cm)</strong></td>
              <td>136g</td>
              <td>121 kcal</td>
              <td>17g</td>
            </tr>
            <tr>
              <td><strong>Extra grande (&gt;23 cm)</strong></td>
              <td>152g</td>
              <td>135 kcal</td>
              <td>19g</td>
            </tr>
          </tbody>
        </table>

        <p><strong>Nota importante:</strong> Estas calorías son para plátano crudo. Los plátanos no cambian significativamente en calorías si los cocinas, pero sí si los deshidratas (se concentran).</p>

        <h2>Plátano vs Otras Frutas: Comparación de Calorías</h2>

        <table class="comparison-table">
          <thead>
            <tr>
              <th>Fruta (100g)</th>
              <th>Calorías</th>
              <th>Azúcar</th>
              <th>Fibra</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td><strong>Plátano</strong></td>
              <td>89 kcal</td>
              <td>12g</td>
              <td>2.6g</td>
            </tr>
            <tr>
              <td>Manzana</td>
              <td>52 kcal</td>
              <td>10g</td>
              <td>2.4g</td>
            </tr>
            <tr>
              <td>Naranja</td>
              <td>47 kcal</td>
              <td>9g</td>
              <td>2.4g</td>
            </tr>
            <tr>
              <td>Uvas</td>
              <td>69 kcal</td>
              <td>16g</td>
              <td>0.9g</td>
            </tr>
            <tr>
              <td>Mango</td>
              <td>60 kcal</td>
              <td>14g</td>
              <td>1.6g</td>
            </tr>
            <tr>
              <td>Sandía</td>
              <td>30 kcal</td>
              <td>6g</td>
              <td>0.4g</td>
            </tr>
            <tr>
              <td>Fresas</td>
              <td>33 kcal</td>
              <td>5g</td>
              <td>2g</td>
            </tr>
          </tbody>
        </table>

        <p><strong>Conclusión:</strong> El plátano tiene MÁS calorías que la mayoría de frutas (89 vs 30-60 kcal/100g), pero no es extremadamente alto. Es comparable al mango.</p>

        <h2>Valor Nutricional del Plátano</h2>

        <p>Más allá de las calorías, el plátano es NUTRICIONALMENTE DENSO:</p>

        <h3>Nutrientes en 1 Plátano Mediano (118g)</h3>
        <ul>
          <li><strong>Potasio:</strong> 422mg (12% valor diario) - Crucial para presión arterial, función muscular</li>
          <li><strong>Vitamina B6:</strong> 0.4mg (20% VD) - Metabolismo, función cerebral</li>
          <li><strong>Vitamina C:</strong> 10mg (11% VD) - Antioxidante, sistema inmune</li>
          <li><strong>Magnesio:</strong> 32mg (8% VD) - Función muscular, sueño</li>
          <li><strong>Fibra:</strong> 3.1g (11% VD) - Digestión, saciedad</li>
          <li><strong>Manganeso:</strong> 0.3mg (15% VD) - Metabolismo, huesos</li>
        </ul>

        <h3>Beneficios del Plátano</h3>
        <ol>
          <li><strong>Pre-entrenamiento natural:</strong> Carbohidratos de rápida absorción + potasio previene calambres</li>
          <li><strong>Mejora digestión:</strong> Fibra + almidón resistente alimentan bacterias intestinales buenas</li>
          <li><strong>Regula presión arterial:</strong> Alto potasio + bajo sodio</li>
          <li><strong>Mejora ánimo:</strong> Triptófano → serotonina (hormona de la felicidad)</li>
          <li><strong>Conveniente:</strong> Viene en su propio empaque, portable, no requiere preparación</li>
        </ol>

        <h2>¿El Plátano Verde o el Maduro Engorda Más?</h2>

        <p>Si hablamos del plátano de fruta, <strong>el verde y el maduro tienen prácticamente las mismas calorías</strong> (unas 89 kcal por 100 g). Al madurar no gana energía: el almidón se convierte en azúcar. Por eso el verde sabe menos dulce, tiene más almidón resistente, sube menos el azúcar en sangre y suele saciar un poco más. El maduro se digiere más rápido y va mejor antes de entrenar.</p>

        <p>En Latinoamérica "plátano verde" suele ser otra cosa: el <strong>plátano macho</strong>, el que se cocina. Ahí sí cambian las calorías, y sobre todo por cómo se prepara:</p>

        <table class="comparison-table">
          <thead>
            <tr>
              <th>Plátano macho (por 100 g)</th>
              <th>Calorías aprox.</th>
            </tr>
          </thead>
          <tbody>
            <tr><td><strong>Crudo</strong></td><td>120 kcal</td></tr>
            <tr><td><strong>Hervido o al horno</strong></td><td>115 kcal</td></tr>
            <tr><td><strong>Maduro frito (tajadas)</strong></td><td>unas 240 kcal</td></tr>
            <tr><td><strong>Verde frito (patacones, tostones)</strong></td><td>unas 300 kcal</td></tr>
          </tbody>
        </table>

        <p>Lo que engorda del plátano macho no es el plátano, es el aceite: un plato de patacones puede triplicar las calorías del mismo plátano hervido.</p>

        <h2>Índice Glucémico del Plátano</h2>

        <p>El índice glucémico (IG) del plátano varía MUCHO según su madurez:</p>

        <table class="comparison-table">
          <thead>
            <tr>
              <th>Estado de Madurez</th>
              <th>Índice Glucémico</th>
              <th>Clasificación</th>
              <th>Almidón vs Azúcar</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td><strong>Verde (no maduro)</strong></td>
              <td>30-40</td>
              <td>Bajo</td>
              <td>Alto almidón resistente, bajo azúcar</td>
            </tr>
            <tr>
              <td><strong>Amarillo con puntas verdes</strong></td>
              <td>42-52</td>
              <td>Medio (bajo)</td>
              <td>Almidón convirtiéndose en azúcar</td>
            </tr>
            <tr>
              <td><strong>Amarillo brillante</strong></td>
              <td>51-60</td>
              <td>Medio</td>
              <td>Equilibrio azúcar/almidón</td>
            </tr>
            <tr>
              <td><strong>Amarillo con manchas marrones</strong></td>
              <td>60-70</td>
              <td>Alto (medio)</td>
              <td>Más azúcar, menos almidón</td>
            </tr>
            <tr>
              <td><strong>Muy maduro (marrón)</strong></td>
              <td>70-80</td>
              <td>Alto</td>
              <td>Máximo azúcar, mínimo almidón</td>
            </tr>
          </tbody>
        </table>

        <h3>¿Qué Significa Esto Para Ti?</h3>

        <p><strong>Plátanos verdes/poco maduros:</strong></p>
        <ul>
          <li>Menor IG = Menor pico de azúcar en sangre</li>
          <li>Más almidón resistente (actúa como fibra, alimenta bacterias intestinales)</li>
          <li>PERO más difíciles de digerir, pueden causar hinchazón</li>
          <li><strong>Mejor para:</strong> Control de azúcar en sangre, salud intestinal</li>
        </ul>

        <p><strong>Plátanos muy maduros:</strong></p>
        <ul>
          <li>Mayor IG = Energía rápida</li>
          <li>Más azúcar simple, más dulces</li>
          <li>Más fáciles de digerir</li>
          <li><strong>Mejor para:</strong> Pre/post-entrenamiento, energía rápida</li>
        </ul>

        <h2>¿Cuándo Es el Mejor Momento para Comer Plátano?</h2>

        <h3>1. Pre-Entrenamiento (30-60 min antes)</h3>
        <p><strong>Por qué funciona:</strong></p>
        <ul>
          <li>Carbohidratos de rápida absorción = energía disponible</li>
          <li>Potasio previene calambres musculares</li>
          <li>Fácil de digerir (no te sentirás pesado)</li>
        </ul>
        <p><strong>Mejor opción:</strong> Plátano maduro (amarillo con manchas)</p>

        <h3>2. Post-Entrenamiento (dentro de 30-60 min)</h3>
        <p><strong>Por qué funciona:</strong></p>
        <ul>
          <li>Repone glucógeno muscular rápidamente</li>
          <li>Potasio + magnesio ayudan recuperación muscular</li>
          <li>Vitamina B6 ayuda metabolismo proteico</li>
        </ul>
        <p><strong>Mejor opción:</strong> Plátano + fuente de proteína (yogur griego, proteína en polvo)</p>

        <h3>3. Desayuno</h3>
        <p><strong>Por qué funciona:</strong></p>
        <ul>
          <li>Energía para empezar el día</li>
          <li>Fibra te mantiene lleno</li>
          <li>Triptófano mejora el ánimo</li>
        </ul>
        <p><strong>Mejor opción:</strong> Plátano con avena o en smoothie con proteína</p>

        <h3>4. Snack Entre Comidas</h3>
        <p><strong>Por qué funciona:</strong></p>
        <ul>
          <li>Portable, conveniente</li>
          <li>Dulce natural que satisface antojos</li>
          <li>Más saciante que galletas/dulces procesados</li>
        </ul>

        <h3>¿Cuándo EVITAR Plátanos?</h3>

        <p><strong>❌ Justo antes de dormir:</strong></p>
        <ul>
          <li>Carbohidratos pueden interrumpir sueño en algunas personas</li>
          <li>Mejor: proteína o grasa (mantequilla de maní) antes de dormir</li>
        </ul>

        <p><strong>❌ Si tienes diabetes descontrolada:</strong></p>
        <ul>
          <li>Consulta médico sobre porciones apropiadas</li>
          <li>Mejor: plátanos menos maduros (menor IG)</li>
        </ul>

        <h2>¿Cuántos Plátanos Puedo Comer al Día?</h2>

        <table class="comparison-table">
          <thead>
            <tr>
              <th>Objetivo</th>
              <th>Plátanos Recomendados/Día</th>
              <th>Razonamiento</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td><strong>Pérdida de peso activa</strong></td>
              <td>1 plátano mediano</td>
              <td>105 kcal manejables en déficit, pero no excedas</td>
            </tr>
            <tr>
              <td><strong>Mantenimiento</strong></td>
              <td>1-2 plátanos medianos</td>
              <td>210 kcal total, equilibrado con otras frutas</td>
            </tr>
            <tr>
              <td><strong>Ganancia muscular/atleta</strong></td>
              <td>2-3 plátanos medianos</td>
              <td>315 kcal, buen combustible para entrenamientos</td>
            </tr>
            <tr>
              <td><strong>Endurance (maratón, ciclismo)</strong></td>
              <td>3-4 plátanos</td>
              <td>420 kcal, fuente rápida de energía durante ejercicio prolongado</td>
            </tr>
          </tbody>
        </table>

        <p><strong>Advertencia:</strong> Comer >5-6 plátanos diarios puede causar hiperpotasemia (exceso de potasio) en personas con problemas renales. Para personas sanas, el cuerpo regula bien el potasio.</p>

        <h2>Cómo Comer Plátano Sin Engordar</h2>

        <h3>1. Controla el Tamaño</h3>
        <p>Un plátano "grande" puede tener 30-40 kcal MÁS que uno mediano. Si estás en déficit estricto, elige plátanos medianos o pequeños.</p>

        <h3>2. Combínalo con Proteína</h3>
        <div class="example-box">
          <p><strong>Snack Saciante (250 kcal):</strong></p>
          <ul>
            <li>1 plátano mediano (105 kcal)</li>
            <li>2 cucharadas mantequilla de maní (190 kcal)</li>
          </ul>
          <p><strong>Total: 295 kcal | Proteína: 8g | Te mantiene lleno 3-4 horas</strong></p>
        </div>

        <h3>3. Úsalo Como Sustituto de Azúcar</h3>
        <ul>
          <li>Plátano machacado en panqueques = endulzante natural</li>
          <li>Plátano congelado licuado = "nice cream" (helado saludable)</li>
          <li>Plátano maduro en avena = no necesitas azúcar añadido</li>
        </ul>

        <h3>4. Cuenta las Calorías (Como Cualquier Alimento)</h3>
        <p>Un plátano grande es ~120 kcal. Dos plátanos grandes = 240 kcal. Si estás en déficit de 1,500 kcal/día, esto es 16% de tu presupuesto. Planifica en consecuencia.</p>

        <h2>Mitos Sobre el Plátano</h2>

        <h3>Mito #1: "El Plátano Tiene Demasiado Azúcar"</h3>
        <p><strong>Realidad:</strong> 1 plátano mediano = 14g azúcar. Una manzana mediana = 19g azúcar. Las uvas tienen MÁS azúcar por gramo que plátanos. El azúcar del plátano NO es peor que el de otras frutas.</p>

        <h3>Mito #2: "Los Plátanos Causan Aumento de Peso"</h3>
        <p><strong>Realidad:</strong> Los plátanos NO causan aumento de peso. El EXCESO de calorías totales causa aumento de peso. Puedes comer plátanos todos los días y perder peso si estás en déficit calórico.</p>

        <h3>Mito #3: "Los Plátanos No Son Buenos Para Diabéticos"</h3>
        <p><strong>Realidad:</strong> Depende. Plátanos VERDES (IG bajo) son perfectamente aceptables para diabéticos en porciones controladas. Plátanos MUY maduros sí elevan azúcar más rápido. La moderación y elección de madurez importan.</p>

        <h3>Mito #4: "Los Plátanos Engordan Más por la Noche"</h3>
        <p><strong>Realidad:</strong> Las calorías son las mismas a las 9 AM que a las 9 PM. El timing NO afecta si engordas o no. Lo que importa es el total de calorías del día.</p>

        <h2>Recetas Saludables con Plátano</h2>

        <h3>1. Nice Cream de Plátano (120 kcal)</h3>
        <div class="example-box">
          <p><strong>Ingredientes:</strong></p>
          <ul>
            <li>2 plátanos congelados (210 kcal)</li>
            <li>1 cucharada cacao puro (12 kcal)</li>
            <li>Edulcorante opcional</li>
          </ul>
          <p><strong>Preparación:</strong> Licuar plátanos congelados hasta cremoso, añadir cacao.</p>
          <p><strong>Porciones: 2 | Calorías/porción: 111 kcal</strong></p>
        </div>

        <h3>2. Panqueques de Plátano (2 panqueques = 180 kcal)</h3>
        <div class="example-box">
          <p><strong>Ingredientes:</strong></p>
          <ul>
            <li>1 plátano maduro (105 kcal)</li>
            <li>2 huevos (140 kcal)</li>
            <li>Canela</li>
          </ul>
          <p><strong>Preparación:</strong> Machacar plátano, batir con huevos, cocinar en sartén antiadherente.</p>
          <p><strong>Total: 245 kcal / 2 panqueques</strong></p>
        </div>

        <h3>3. Smoothie Energético Pre-Entrenamiento (280 kcal)</h3>
        <div class="example-box">
          <p><strong>Ingredientes:</strong></p>
          <ul>
            <li>1 plátano (105 kcal)</li>
            <li>1 scoop proteína vainilla (100 kcal)</li>
            <li>200ml leche desnatada (70 kcal)</li>
            <li>Hielo</li>
          </ul>
          <p><strong>Macros: 275 kcal | Proteína: 28g | Carbos: 35g</strong></p>
        </div>

        <h2>Preguntas Frecuentes</h2>

        <div class="faq-section">
          <h3>¿Puedo comer plátano todos los días y perder peso?</h3>
          <p>SÍ, absolutamente. Siempre que estés en déficit calórico, puedes comer plátano diariamente y perder peso. Un plátano mediano (105 kcal) encaja fácilmente en cualquier plan de pérdida de peso de 1,500+ kcal/día.</p>

          <h3>¿El plátano verde es mejor para adelgazar?</h3>
          <p>No necesariamente "mejor", pero tiene ventajas: menor índice glucémico, más almidón resistente (fibra-like), puede mejorar saciedad. PERO las calorías son las mismas. Elige según preferencia y tolerancia digestiva.</p>

          <h3>¿Cuántos plátanos son demasiados?</h3>
          <p>Para personas sanas, <5-6 plátanos/día es seguro. Más allá puede causar exceso de potasio en personas con problemas renales. Para pérdida de peso, 1-2/día es razonable (105-210 kcal total).</p>

          <h3>¿El plátano deshidratado tiene las mismas calorías?</h3>
          <p>NO. Los chips de plátano deshidratados tienen ~350-500 kcal/100g (4-5x MÁS que plátano fresco) porque el agua se evapora, concentrando azúcar y calorías. Además, muchos chips comerciales tienen azúcar o aceite añadido.</p>

          <h3>¿Es mejor comer plátano antes o después del gym?</h3>
          <p>Ambos momentos son buenos. PRE-gym (30-60 min antes): energía rápida para entrenar. POST-gym (inmediatamente después): repone glucógeno muscular. Si solo puedes elegir uno, POST-gym es ligeramente más beneficioso para recuperación.</p>

          <h3>¿Los plátanos orgánicos son mejores?</h3>
          <p>Nutricionalmente, casi idénticos. Los orgánicos pueden tener menos residuos de pesticidas, pero el plátano tiene cáscara gruesa que de todas formas no comes. Para pérdida de peso, no hay diferencia. Elige según presupuesto y preferencia.</p>
        </div>

        <h2>Conclusión: El Plátano Es Tu Aliado</h2>

        <div class="key-takeaways">
          <h3>🎯 Puntos Clave</h3>
          <ul>
            <li><strong>1 plátano mediano = 105 kcal</strong> - No es excesivamente alto</li>
            <li><strong>NO engorda</strong> más que otras frutas con calorías similares</li>
            <li><strong>Alto en potasio</strong>, vitamina B6, fibra - muy nutritivo</li>
            <li><strong>Perfecto pre/post-entrenamiento</strong> por carbohidratos de rápida absorción</li>
            <li><strong>1-2 plátanos/día</strong> es razonable en pérdida de peso</li>
            <li><strong>Madurez importa:</strong> Verde = bajo IG, Maduro = energía rápida</li>
            <li><strong>Combínalo con proteína</strong> para mayor saciedad</li>
          </ul>
        </div>

        <p>El plátano no merece su mala reputación. Es una fruta conveniente, nutritiva y versátil que puede formar parte perfectamente de una dieta de pérdida de peso. Como con cualquier alimento, la clave está en el control de porciones y en cómo encaja en tu presupuesto calórico total del día.</p>

        <div class="cta-box">
          <h3>📸 Escanea Tu Plátano con Wayo</h3>
          <p>¿Ese plátano es pequeño, mediano o grande? Con <strong>Wayo</strong>, escanéalo y sabrás exactamente cuántas calorías tiene.</p>
          <ul>
            <li>📸 Detección automática de tamaño</li>
            <li>🎯 Calorías precisas por plátano</li>
            <li>📊 Tracking de frutas diarias</li>
            <li>💡 Sugerencias de porciones óptimas</li>
          </ul>
          <p><a href="https://wayoai.app/download" class="cta-button">Prueba Wayo Gratis</a></p>
        </div>

        <div class="related-articles">
          <h3>Artículos Relacionados</h3>
          <ul>
            <li>Calorías de las Frutas: Cuáles Engordan</li>
            <li>¿La Fruta Engorda? Mitos y Verdades</li>
            <li>Snacks Saludables Bajo 100 Calorías</li>
            <li><a href="/blog/cuantas-calorias-para-bajar-1-kilo">¿Cuántas Calorías Para Bajar 1 Kilo?</a></li>
          </ul>
        </div>
      </div>
    `
  },
  {
    id: 147,
    title: "Calorías del Café: Cuál Engorda Más y Cómo Pedirlo Mejor",
    slug: "calorias-cafe-tipos-comparacion",
    author: "Wayo Nutrition Team",
    date: "2026-01-30",
    readTime: "12 min",
    category: "Nutrición",
    image: "https://images.unsplash.com/photo-1511537190424-bbbab87ac5eb?w=1200",
    excerpt: "¿Cuántas calorías tiene tu café favorito? Comparamos café negro, con leche, capuchino, latte, frappuccino y más. Descubre cómo reducir calorías sin sacrificar sabor.",
    metaDescription: "Comparamos café solo, con leche, latte, capuchino y más para que sepas cuál suma más calorías y cómo recortarlas sin perder sabor.",
    keywords: ["calorías café", "café con leche calorías", "capuchino calorías", "latte calorías", "frappuccino calorías"],
    tags: ["café", "bebidas", "calorías", "Starbucks"],
    content: `
      <div class="blog-article-extended">
        <h2>Tu Café Diario: ¿Inocente o Bomba Calórica?</h2>
        <p>El café negro tiene prácticamente 0 calorías. Pero ese latte con leche entera, sirope de vainilla y crema batida que tomas cada mañana puede tener tantas calorías como una comida completa.</p>

        <p>En este artículo, vamos a desglosar las calorías de TODOS los tipos de café populares, desde el simple café negro hasta los frappuccinos más elaborados de Starbucks.</p>

        <div class="info-box">
          <h3>⚡ Lo Más Importante</h3>
          <ul>
            <li>Café negro = 2-5 kcal</li>
            <li>Café con leche = 30-200+ kcal (depende del tipo de leche y cantidad)</li>
            <li>Frappuccino grande = 300-500+ kcal (equivalente a una comida)</li>
            <li>Pequeños cambios (leche desnatada, sin sirope) ahorran 100-200 kcal</li>
          </ul>
        </div>

        <h2>Calorías del Café: La Tabla Completa</h2>

        <h3>Café Básico (Sin Añadidos)</h3>
        <table class="comparison-table">
          <thead>
            <tr>
              <th>Tipo de Café</th>
              <th>Tamaño</th>
              <th>Calorías</th>
              <th>Cafeína</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td><strong>Café negro (filtro)</strong></td>
              <td>240ml (taza)</td>
              <td>2 kcal</td>
              <td>95mg</td>
            </tr>
            <tr>
              <td><strong>Espresso</strong></td>
              <td>30ml (shot)</td>
              <td>3 kcal</td>
              <td>63mg</td>
            </tr>
            <tr>
              <td><strong>Americano</strong></td>
              <td>240ml</td>
              <td>5 kcal</td>
              <td>150mg</td>
            </tr>
            <tr>
              <td><strong>Café instantáneo</strong></td>
              <td>240ml</td>
              <td>4 kcal</td>
              <td>65mg</td>
            </tr>
            <tr>
              <td><strong>Café descafeinado</strong></td>
              <td>240ml</td>
              <td>2 kcal</td>
              <td>2-5mg</td>
            </tr>
          </tbody>
        </table>

        <p><strong>Conclusión:</strong> El café SOLO es prácticamente libre de calorías. El problema comienza cuando añades leche, azúcar, siropes...</p>

        <h3>Café con Leche (Según Tipo de Leche)</h3>
        <table class="comparison-table">
          <thead>
            <tr>
              <th>Tipo</th>
              <th>240ml Café + 60ml Leche</th>
              <th>Calorías</th>
              <th>Proteína</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td><strong>Café + leche entera</strong></td>
              <td>1/4 taza leche</td>
              <td>38 kcal</td>
              <td>2g</td>
            </tr>
            <tr>
              <td><strong>Café + leche semidesnatada</strong></td>
              <td>1/4 taza leche</td>
              <td>24 kcal</td>
              <td>2g</td>
            </tr>
            <tr>
              <td><strong>Café + leche desnatada</strong></td>
              <td>1/4 taza leche</td>
              <td>13 kcal</td>
              <td>2g</td>
            </tr>
            <tr>
              <td><strong>Café + leche de almendras sin azúcar</strong></td>
              <td>1/4 taza leche</td>
              <td>8 kcal</td>
              <td>0.3g</td>
            </tr>
            <tr>
              <td><strong>Café + leche de soja</strong></td>
              <td>1/4 taza leche</td>
              <td>20 kcal</td>
              <td>1.8g</td>
            </tr>
            <tr>
              <td><strong>Café + leche de avena</strong></td>
              <td>1/4 taza leche</td>
              <td>30 kcal</td>
              <td>0.6g</td>
            </tr>
            <tr>
              <td><strong>Café + leche de coco</strong></td>
              <td>1/4 taza leche</td>
              <td>11 kcal</td>
              <td>0.1g</td>
            </tr>
          </tbody>
        </table>

        <p><strong>Ahorro potencial:</strong> Cambiar de leche entera a desnatada o almendras = <strong>25-30 kcal menos</strong> por café. Si tomas 2-3 cafés/día = 50-90 kcal/día ahorradas.</p>

        <h2>Cafés de Cafetería: Starbucks, Costa, Dunkin'</h2>

        <h3>Café Básico de Cafetería (Tamaño Grande/Venti ~480ml)</h3>
        <table class="comparison-table">
          <thead>
            <tr>
              <th>Tipo de Café</th>
              <th>Con Leche Entera</th>
              <th>Con Leche Desnatada</th>
              <th>Diferencia</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td><strong>Café con leche (Latte)</strong></td>
              <td>220 kcal</td>
              <td>130 kcal</td>
              <td>-90 kcal</td>
            </tr>
            <tr>
              <td><strong>Capuchino</strong></td>
              <td>140 kcal</td>
              <td>80 kcal</td>
              <td>-60 kcal</td>
            </tr>
            <tr>
              <td><strong>Flat White</strong></td>
              <td>220 kcal</td>
              <td>130 kcal</td>
              <td>-90 kcal</td>
            </tr>
            <tr>
              <td><strong>Macchiato</strong></td>
              <td>190 kcal</td>
              <td>110 kcal</td>
              <td>-80 kcal</td>
            </tr>
            <tr>
              <td><strong>Mocha</strong></td>
              <td>360 kcal</td>
              <td>290 kcal</td>
            </tr>
          </tbody>
        </table>

        <p>Continúa leyendo para ver comparaciones de cafés populares...</p>

        <div class="cta-box">
          <h3>📸 Escanea Tu Café con Wayo</h3>
          <p>Con <strong>Wayo</strong>, descubre exactamente cuántas calorías tiene tu café favorito.</p>
          <p><a href="https://wayoai.app/download" class="cta-button">Prueba Wayo Gratis</a></p>
        </div>
      </div>
    `
  },
  {
    id: 148,
    title: "¿La Pasta Engorda? Cómo Comerla Sin Fastidiar tu Progreso",
    slug: "la-pasta-engorda-como-comer",
    faqSchema: {
        "@context": "https://schema.org",
        "@type": "FAQPage",
        "mainEntity": [
            {
                "@type": "Question",
                "name": "¿La pasta engorda?",
                "acceptedAnswer": {
                    "@type": "Answer",
                    "text": "No. 100 g de pasta cocida son unas 120 kcal, menos que el arroz cocido. Lo que engorda es la ración doble y la salsa: un plato con tomate son 320 kcal y el mismo con carbonara, 750."
                }
            },
            {
                "@type": "Question",
                "name": "¿Cuánta pasta puedo comer al día?",
                "acceptedAnswer": {
                    "@type": "Answer",
                    "text": "La ración estándar son 80 g en seco, unos 230 g cocida y 280 kcal. Cabe en cualquier dieta de pérdida de peso siempre que el resto del día cuadre."
                }
            },
            {
                "@type": "Question",
                "name": "¿Comer pasta por la noche engorda?",
                "acceptedAnswer": {
                    "@type": "Answer",
                    "text": "No. Lo que determina si ganas o pierdes peso es el balance del día completo, no la hora a la que comes."
                }
            },
            {
                "@type": "Question",
                "name": "¿Es mejor la pasta integral para adelgazar?",
                "acceptedAnswer": {
                    "@type": "Answer",
                    "text": "Tiene prácticamente las mismas calorías pero el triple de fibra, así que sacia más y hace que comas menos del resto. Ayuda, pero no adelgaza por sí sola."
                }
            },
            {
                "@type": "Question",
                "name": "¿Cuántas calorías tiene un plato de pasta?",
                "acceptedAnswer": {
                    "@type": "Answer",
                    "text": "Entre 320 y 800 kcal según la salsa, partiendo de 80 g en seco. Con tomate natural 320, con boloñesa magra 480, con carbonara 750."
                }
            }
        ]
    },
    seoTitle: "¿La Pasta Engorda? 120 kcal por 100 g Cocida (la Verdad)",
    author: "Wayo Nutrition Team",
    date: "2026-01-29",
    readTime: "7 min",
    category: "Nutrición",
    image: "https://images.unsplash.com/photo-1621996346565-e3dbc646d9a9?w=1200",
    excerpt: "¿La pasta engorda o es un mito? Descubre cuántas calorías tiene, diferencias entre blanca e integral, porciones correctas y trucos para incluirla sin engordar.",
    metaDescription: "La pasta cocida son 120 kcal por 100 g, menos que el arroz. Lo que engorda es la ración y la salsa: de 320 a 800 kcal con la misma pasta. Tablas y cómo comerla.",
    keywords: ["pasta engorda", "calorías pasta", "pasta blanca vs integral", "cuánta pasta comer", "pasta para adelgazar"],
    tags: ["pasta", "carbohidratos", "calorías", "pérdida de peso"],
    content: `
      <div class="blog-article-extended">
        <p class="lead"><strong>La pasta no engorda.</strong> 100 g de pasta seca son 350 kcal, pero eso son unos 220 g ya cocida, que es un plato normal. Lo que engorda es la ración de 150 g en seco con carbonara encima, que se va a 900 kcal sin que lo parezca.</p>

        <h2>Las calorías reales de la pasta</h2>

        <p>El error número uno con la pasta es confundir el peso en crudo con el peso en el plato. La pasta <strong>triplica su peso al cocerse</strong> porque absorbe agua, y el agua no tiene calorías.</p>

        <table class="comparison-table">
          <thead>
            <tr><th>Cantidad</th><th>Peso cocida</th><th>Calorías</th></tr>
          </thead>
          <tbody>
            <tr><td><strong>60 g en seco</strong> (ración pequeña)</td><td>~170 g</td><td>210 kcal</td></tr>
            <tr><td><strong>80 g en seco</strong> (ración estándar)</td><td>~230 g</td><td>280 kcal</td></tr>
            <tr><td><strong>100 g en seco</strong></td><td>~290 g</td><td>350 kcal</td></tr>
            <tr><td><strong>150 g en seco</strong> (lo que suele caer)</td><td>~430 g</td><td>525 kcal</td></tr>
          </tbody>
        </table>

        <div class="info-box">
          <h3>El número que te sirve</h3>
          <p><strong>Pasta cocida: ~120 kcal por cada 100 g.</strong> Menos que el arroz cocido y bastante menos de lo que casi todo el mundo cree.</p>
        </div>

        <h2>Entonces, ¿por qué la pasta tiene fama de engordar?</h2>

        <p>Por tres motivos, y ninguno es la pasta.</p>

        <h3>1. La salsa pesa más que el plato</h3>

        <p>Aquí está casi todo el problema:</p>

        <table class="comparison-table">
          <thead>
            <tr><th>80 g de pasta con...</th><th>Total del plato</th></tr>
          </thead>
          <tbody>
            <tr><td>Tomate natural y albahaca</td><td><strong>320 kcal</strong></td></tr>
            <tr><td>Boloñesa casera con carne magra</td><td><strong>480 kcal</strong></td></tr>
            <tr><td>Pesto (2 cucharadas)</td><td><strong>560 kcal</strong></td></tr>
            <tr><td>Carbonara con nata y bacon</td><td><strong>750 kcal</strong></td></tr>
            <tr><td>Cuatro quesos</td><td><strong>800 kcal</strong></td></tr>
          </tbody>
        </table>

        <p>El mismo plato de pasta pasa de 320 a 800 kcal sin tocar un gramo de pasta. <strong>Cuando alguien dice que la pasta le engorda, casi siempre está hablando de la nata.</strong></p>

        <h3>2. Nadie pesa la pasta</h3>

        <p>Un plato hondo lleno son fácilmente 150 g en seco. La ración de referencia son 80. Es el doble sin que nadie lo perciba, porque la pasta se sirve por volumen y no por peso.</p>

        <h3>3. Es de las pocas cosas que se comen sin freno</h3>

        <p>La pasta sacia menos que la patata o el arroz por caloría, sobre todo si es refinada y va con salsa cremosa. Se come rápido, entra fácil y se repite.</p>

        <h2>Cómo comer pasta sin fastidiar el déficit</h2>

        <ul>
          <li><strong>Pesa en seco una vez.</strong> Solo una. Pon 80 g en tu plato habitual, mira dónde llega y ya no vuelves a necesitar la báscula.</li>
          <li><strong>Cambia la proporción, no el plato.</strong> Menos pasta y más verdura y proteína encima: mismo volumen, 200 kcal menos y bastante más saciante.</li>
          <li><strong>Cuécela al dente.</strong> Menos cocción, menos índice glucémico y más masticado, que es un freno natural.</li>
          <li><strong>Salsa de tomate como base.</strong> El tomate frito casero cuesta 40-60 kcal por ración; la nata, 200.</li>
          <li><strong>Mete proteína de verdad:</strong> atún, pollo, huevo, gambas, ternera magra. Es lo que convierte un plato de pasta en una comida completa.</li>
          <li><strong>Ojo con el aceite de la sartén.</strong> Un chorro generoso son 3 cucharadas: 270 kcal invisibles.</li>
        </ul>

        <div class="example-box">
          <p><strong>El mismo plato, dos versiones:</strong></p>
          <p><strong>Versión pesada:</strong> 150 g de pasta + carbonara con nata y bacon = <strong>1.000 kcal</strong>, y con hambre otra vez a las dos horas.</p>
          <p><strong>Versión que funciona:</strong> 80 g de pasta + 150 g de calabacín y champiñón + 120 g de pollo + tomate = <strong>520 kcal</strong>, el plato se ve MÁS grande y aguantas hasta la cena.</p>
        </div>

        <h2>¿Integral o normal?</h2>

        <p>La diferencia calórica es mínima: 350 kcal la refinada y 340 la integral por 100 g en seco. Prácticamente lo mismo.</p>

        <p>La diferencia real está en la fibra: la integral tiene el triple (unos 8 g por 100 g frente a 3), y eso significa digestión más lenta y más saciedad. <strong>No adelgaza por sí sola, pero hace que comas menos del resto del día.</strong> Si te gusta, cámbiate; si la odias, comer pasta normal con verdura te da un resultado equivalente.</p>

        <h2>¿Y la pasta por la noche?</h2>

        <p>No pasa nada. Tu cuerpo no lleva reloj: lo que cuenta es el total del día, no la hora a la que entra. La idea de que "los carbohidratos por la noche se convierten en grasa" no tiene respaldo.</p>

        <p>De hecho, para bastante gente cenar pasta funciona mejor: sacia, ayuda a dormir y evita el asalto a la nevera a las once. Si tu total del día cuadra, cena pasta tranquilo.</p>

        <h2>Preguntas frecuentes</h2>

        <div class="faq-section">
          <h3>¿La pasta engorda?</h3>
          <p>No. 100 g de pasta cocida son unas 120 kcal, menos que el arroz cocido. Lo que engorda es la ración doble y la salsa: un plato con tomate son 320 kcal y el mismo con carbonara, 750.</p>

          <h3>¿Cuánta pasta puedo comer al día?</h3>
          <p>La ración estándar son 80 g en seco (unos 230 g cocida, 280 kcal). Cabe perfectamente en cualquier dieta de pérdida de peso siempre que el resto del día cuadre.</p>

          <h3>¿Comer pasta por la noche engorda?</h3>
          <p>No. Lo que determina si ganas o pierdes peso es el balance del día completo, no la hora. Cenar pasta incluso ayuda a algunas personas a no picar después.</p>

          <h3>¿Es mejor la pasta integral para adelgazar?</h3>
          <p>Tiene prácticamente las mismas calorías, pero el triple de fibra, así que sacia más y te hace comer menos del resto. Ayuda, pero no adelgaza por sí sola.</p>

          <h3>¿Cuántas calorías tiene un plato de pasta?</h3>
          <p>Entre 320 y 800 kcal según la salsa, partiendo de 80 g en seco. Con tomate natural, 320; con boloñesa magra, 480; con carbonara, 750.</p>
        </div>

        <div class="key-takeaways">
          <h3>Lo que hay que recordar</h3>
          <ul>
            <li><strong>Pasta cocida: 120 kcal / 100 g.</strong> Menos que el arroz cocido.</li>
            <li><strong>La pasta triplica su peso al cocer.</strong> No confundas crudo con plato.</li>
            <li><strong>La salsa decide:</strong> de 320 a 800 kcal con la misma pasta.</li>
            <li><strong>Pesa 80 g una sola vez</strong> y calibra el ojo para siempre.</li>
            <li><strong>Por la noche no engorda.</strong> El día completo es lo que cuenta.</li>
          </ul>
        </div>

        <div class="cta-box">
          <h3>La salsa es lo que no se ve en el plato</h3>
          <p>Y es justo lo que se escapa al apuntar a mano. Con <strong>Wayo</strong> haces una foto y te da calorías y macros del plato entero, salsa y aceite incluidos.</p>
          <p><a href="https://wayoai.app/download" class="cta-button">Probar Wayo</a></p>
        </div>

        <div class="related-articles">
          <h3>Sigue leyendo</h3>
          <ul>
            <li><a href="/blog/el-arroz-engorda-calorias-como-comer">¿El arroz engorda?</a></li>
            <li><a href="/blog/las-patatas-engordan-calorias-verdad">¿Las patatas engordan?</a></li>
            <li><a href="/blog/cuantas-calorias-tiene-comida-espanola-latina-guia">Calorías de los platos españoles y latinos</a></li>
            <li><a href="/blog/alimentos-bajos-calorias-perder-peso">50 alimentos bajos en calorías que sacian</a></li>
          </ul>
        </div>
      </div>
    `
  },
  {
    id: 149,
    slug: "alimentos-cero-calorias-opciones",
    faqSchema: {
        "@context": "https://schema.org",
        "@type": "FAQPage",
        "mainEntity": [
            {
                "@type": "Question",
                "name": "¿Qué alimento tiene cero calorías?",
                "acceptedAnswer": {
                    "@type": "Answer",
                    "text": "Solo el agua, incluida el agua con gas. Todo lo demás aporta algo. Lo más cercano son los berros (11 kcal por 100 g), el pepinillo en vinagre (12) y la lechuga iceberg (14)."
                }
            },
            {
                "@type": "Question",
                "name": "¿Existen los alimentos de calorías negativas?",
                "acceptedAnswer": {
                    "@type": "Answer",
                    "text": "No. Digerir un alimento gasta como mucho un 30 % de su energía, y solo con proteína pura, así que el saldo siempre es positivo. Un apio de 16 kcal deja unas 12 kcal netas."
                }
            },
            {
                "@type": "Question",
                "name": "¿Puedo comer todo el pepino y la lechuga que quiera?",
                "acceptedAnswer": {
                    "@type": "Answer",
                    "text": "En la práctica sí, porque el estómago se llena antes de que las calorías importen: un kilo de pepino son 150 kcal. Pero sin límite no significa sin calorías."
                }
            },
            {
                "@type": "Question",
                "name": "¿El café y el té engordan?",
                "acceptedAnswer": {
                    "@type": "Answer",
                    "text": "Solos no: 1 o 2 kcal por taza. Lo que suma es lo que se les añade. Un café con leche entera y azúcar pasa de 2 a más de 100 kcal."
                }
            }
        ]
    },
    seoTitle: "Alimentos con 0 Calorías: los 24 que Menos Suman (Tabla)",
    title: "24 Alimentos con Casi Cero Calorías (Tabla Real por 100 g)",
    author: "Wayo Nutrition Team",
    date: "2026-01-28",
    readTime: "7 min",
    category: "Nutrición",
    image: "https://images.unsplash.com/photo-1540420773420-3366772f4999?w=1200",
    excerpt: "Descubre 20 alimentos con calorías casi nulas que puedes comer prácticamente sin límite: vegetales, condimentos, bebidas y más para llenar tu plato sin culpa.",
    metaDescription: "Ningún alimento tiene 0 calorías, pero estos 24 casi. Tabla con kcal por 100 g, por qué las calorías negativas son un mito y cómo usarlos para comer más.",
    keywords: ["alimentos cero calorías", "alimentos sin calorías", "qué comer sin engordar", "vegetales bajos en calorías", "comida volumen cero calorías"],
    tags: ["bajas calorías", "vegetales", "volumen", "dieta"],
    content: `
      <div class="blog-article-extended">
        <p class="lead">Empecemos por lo honesto: <strong>ningún alimento tiene cero calorías.</strong> Ni el apio, ni el pepino, ni el agua con limón. Lo que sí existe son alimentos tan bajos en energía que puedes comer un plato enorme y apenas mover tu total del día. Esa es la lista de abajo, con los números reales.</p>

        <div class="warning-box">
          <h3>Y no, tampoco existen las "calorías negativas"</h3>
          <p>Vas a leer por ahí que el apio "quema más calorías de las que aporta" al digerirlo. Es falso. Digerir un alimento gasta entre un 5 % y un 30 % de su energía según el nutriente, así que un apio de 16 kcal te sigue dejando un saldo positivo de unas 12. Es poquísimo, pero es positivo.</p>
          <p>La utilidad de estos alimentos no está en el mito. Está en el <strong>volumen</strong>: llenan el estómago por muy poca energía, y el estómago lleno es lo que hace que un déficit se pueda sostener.</p>
        </div>

        <h2>La tabla: 24 alimentos por debajo de 40 kcal cada 100 g</h2>

        <h3>Verduras y hortalizas</h3>

        <table class="comparison-table">
          <thead>
            <tr><th>Alimento</th><th>kcal / 100 g</th><th>Para qué sirve de verdad</th></tr>
          </thead>
          <tbody>
            <tr><td><strong>Berros</strong></td><td>11</td><td>Base de ensalada con sabor propio</td></tr>
            <tr><td><strong>Pepino</strong></td><td>15</td><td>Volumen y agua, casi sin sabor</td></tr>
            <tr><td><strong>Lechuga iceberg</strong></td><td>14</td><td>Crujido y cantidad</td></tr>
            <tr><td><strong>Apio</strong></td><td>16</td><td>Picoteo que ocupa tiempo masticando</td></tr>
            <tr><td><strong>Rábano</strong></td><td>16</td><td>Punto picante sin grasa</td></tr>
            <tr><td><strong>Endivia</strong></td><td>17</td><td>Cuchara comestible para untables</td></tr>
            <tr><td><strong>Calabacín</strong></td><td>17</td><td>Sustituye pasta en espirales</td></tr>
            <tr><td><strong>Tomate</strong></td><td>18</td><td>Sabor y ácido, monta cualquier plato</td></tr>
            <tr><td><strong>Acelga</strong></td><td>19</td><td>Se reduce mucho al cocinar, cunde</td></tr>
            <tr><td><strong>Pimiento verde</strong></td><td>20</td><td>Sofritos sin sumar nada</td></tr>
            <tr><td><strong>Espárrago verde</strong></td><td>20</td><td>Plancha rápida, sacia sorprendentemente</td></tr>
            <tr><td><strong>Champiñón</strong></td><td>22</td><td>Textura de carne por 22 kcal</td></tr>
            <tr><td><strong>Espinaca cruda</strong></td><td>23</td><td>Se puede meter en todo sin que se note</td></tr>
            <tr><td><strong>Coliflor</strong></td><td>25</td><td>Sustituye arroz o puré de patata</td></tr>
            <tr><td><strong>Repollo</strong></td><td>25</td><td>Ensaladas que aguantan días</td></tr>
            <tr><td><strong>Berenjena</strong></td><td>25</td><td>Ojo: absorbe aceite como una esponja</td></tr>
            <tr><td><strong>Calabaza</strong></td><td>26</td><td>Dulce sin azúcar, cremas espesas</td></tr>
            <tr><td><strong>Judía verde</strong></td><td>31</td><td>Guarnición de plato entero</td></tr>
            <tr><td><strong>Brócoli</strong></td><td>34</td><td>El que más proteína y fibra aporta de la lista</td></tr>
          </tbody>
        </table>

        <h3>Bebidas y caldos</h3>

        <table class="comparison-table">
          <thead>
            <tr><th>Alimento</th><th>Calorías</th><th>Aviso</th></tr>
          </thead>
          <tbody>
            <tr><td><strong>Agua con gas</strong></td><td>0</td><td>Lo único de verdad a cero</td></tr>
            <tr><td><strong>Té e infusiones</strong></td><td>~1 / taza</td><td>A cero si no le echas nada</td></tr>
            <tr><td><strong>Café solo</strong></td><td>~2 / taza</td><td>Un café con leche y azúcar son 120</td></tr>
            <tr><td><strong>Caldo de verduras desgrasado</strong></td><td>5-10 / taza</td><td>Lo mejor para el hambre de media tarde</td></tr>
            <tr><td><strong>Gelatina sin azúcar</strong></td><td>~6 / ración</td><td>Postre que ocupa espacio</td></tr>
          </tbody>
        </table>

        <h3>Condimentos que dan sabor por nada</h3>

        <p>Aquí está el truco que de verdad marca la diferencia: la razón por la que la gente abandona las verduras no es que engorden, es que están sosas. Estos suman prácticamente cero <em>en la cantidad que se usa</em>:</p>

        <ul>
          <li><strong>Vinagre</strong> (de vino, de manzana, balsámico): 1-3 kcal por cucharada.</li>
          <li><strong>Mostaza:</strong> 3-5 kcal por cucharadita.</li>
          <li><strong>Especias y hierbas</strong> (pimentón, comino, orégano, curry, ajo en polvo): 0-5 kcal por ración.</li>
          <li><strong>Limón y lima:</strong> 4 kcal por medio limón exprimido.</li>
          <li><strong>Salsa de soja:</strong> 8 kcal por cucharada.</li>
          <li><strong>Pepinillos y encurtidos:</strong> 12 kcal / 100 g.</li>
        </ul>

        <div class="warning-box">
          <h3>Donde se cuela el aceite</h3>
          <p>Una ensalada de 200 g de lechuga, tomate y pepino son unas <strong>35 kcal</strong>. Dos cucharadas de aceite de oliva por encima son <strong>180 kcal</strong>. La ensalada acaba siendo un 84 % aceite.</p>
          <p>No es que el aceite sea malo, es que hay que contarlo. Si vas a aliñar, mide con cuchara en vez de con chorro, o usa vinagre y limón para el volumen y guarda el aceite para donde lo notes.</p>
        </div>

        <h2>Cómo se usan de verdad estos alimentos</h2>

        <h3>La regla de la mitad del plato</h3>
        <p>No comas apio a palo seco: no vas a durar. Lo que funciona es <strong>rellenar</strong>. Coge el plato que ya te ibas a comer y sustituye la mitad de la guarnición densa por algo de la tabla de arriba.</p>

        <div class="example-box">
          <p><strong>Antes:</strong> 200 g de arroz + pollo = 480 kcal, plato mediano.</p>
          <p><strong>Después:</strong> 100 g de arroz + 200 g de calabacín y champiñón + el mismo pollo = 330 kcal, y el plato es visiblemente <em>más grande</em>.</p>
          <p>150 kcal menos comiendo más cantidad. Repetido dos veces al día son 300 kcal diarias de déficit sin pasar hambre.</p>
        </div>

        <h3>El truco del caldo antes de comer</h3>
        <p>Una taza de caldo desgrasado 10-15 minutos antes de la comida principal cuesta 10 kcal y llega al estómago antes que el plato. Es de las cosas más baratas que puedes hacer si tu problema es llegar con hambre voraz a la mesa.</p>

        <h3>Lo que no debes hacer</h3>
        <ul>
          <li><strong>Vivir solo de esto.</strong> Estos alimentos casi no tienen proteína ni grasa, y las dos son necesarias. Son el acompañamiento, no la comida.</li>
          <li><strong>Contarlos como "gratis" en la app.</strong> 400 g de verdura al día son 100 kcal reales. Poco, pero no cero.</li>
          <li><strong>Pasarse con la fibra de golpe.</strong> Si hoy comes 100 g de verdura y mañana 600, tu barriga te lo va a hacer saber. Sube poco a poco.</li>
        </ul>

        <h2>Preguntas frecuentes</h2>

        <div class="faq-section">
          <h3>¿Qué alimento tiene cero calorías?</h3>
          <p>Solo el agua, incluida el agua con gas. Todo lo demás aporta algo. Lo más cercano son los berros (11 kcal/100 g), el pepinillo en vinagre (12) y la lechuga iceberg (14).</p>

          <h3>¿Puedo comer todo el pepino y la lechuga que quiera?</h3>
          <p>En la práctica sí, porque el estómago se llena antes de que las calorías importen: comerte un kilo de pepino son 150 kcal y es una cantidad que casi nadie consigue tragar. Pero "sin límite" no significa "sin calorías".</p>

          <h3>¿Existen los alimentos de calorías negativas?</h3>
          <p>No. El efecto térmico de la digestión gasta como mucho un 30 % de la energía del alimento (y eso solo con proteína pura), así que el saldo siempre es positivo. Es un mito de internet que no aguanta ningún cálculo.</p>

          <h3>¿El café y el té engordan?</h3>
          <p>Solos no: 1-2 kcal por taza. Lo que engorda es lo que les echas. Un café con leche entera, azúcar y una galleta pasa de 2 a 180 kcal, y como se toma tres veces al día suele ser un agujero de 400 kcal diarias que nadie apunta.</p>

          <h3>¿Sirven de algo si estoy contando calorías?</h3>
          <p>Muchísimo, pero no por lo que la gente cree. No sirven porque "no cuenten": sirven porque te permiten comer platos grandes dentro de tu presupuesto y llegar a la noche sin hambre, que es la razón número uno por la que se abandona una dieta.</p>
        </div>

        <div class="key-takeaways">
          <h3>Lo que hay que recordar</h3>
          <ul>
            <li><strong>Cero calorías solo el agua.</strong> El resto es "muy poco", no "nada".</li>
            <li><strong>Las calorías negativas son un mito.</strong> Digerir nunca cuesta más de lo que aporta.</li>
            <li><strong>El valor está en el volumen,</strong> no en el número: llenan por muy poca energía.</li>
            <li><strong>Sustituye la mitad de la guarnición,</strong> no toda la comida.</li>
            <li><strong>El aliño es donde se va todo:</strong> mide el aceite con cuchara.</li>
          </ul>
        </div>

        <div class="cta-box">
          <h3>Comprueba cuánto sube realmente tu plato</h3>
          <p>La diferencia entre 100 y 200 g de arroz no se ve a ojo, y ahí es donde se decide el déficit. Con <strong>Wayo</strong> haces una foto y tienes calorías y macros en segundos, verduras y aliño incluidos.</p>
          <p><a href="https://wayoai.app/download" class="cta-button">Probar Wayo</a></p>
        </div>

        <div class="related-articles">
          <h3>Sigue leyendo</h3>
          <ul>
            <li><a href="/blog/alimentos-bajos-calorias-perder-peso">50 alimentos bajos en calorías que sacian</a></li>
            <li><a href="/blog/alimentos-calorias-negativas-mito-realidad">Alimentos de calorías negativas: mito y realidad</a></li>
            <li><a href="/blog/que-cenar-para-bajar-de-peso">Qué cenar para bajar de peso</a></li>
            <li><a href="/blog/cuantas-calorias-para-bajar-1-kilo">Cuántas calorías son 1 kilo</a></li>
          </ul>
        </div>
      </div>
    `
  },
  {
    id: 150,
    title: "¿Cuántas Calorías Tiene un Huevo? Comparativa por Preparación",
    slug: "cuantas-calorias-huevo-preparacion",
    faqSchema: {
        "@context": "https://schema.org",
        "@type": "FAQPage",
        "mainEntity": [
            {
                "@type": "Question",
                "name": "¿Cuántas calorías tiene un huevo?",
                "acceptedAnswer": {
                    "@type": "Answer",
                    "text": "Unas 72 kcal si es mediano (M) y está cocido, escalfado o pasado por agua. Un huevo L son unas 84 kcal y uno XL unas 95. La preparación puede duplicar esa cifra."
                }
            },
            {
                "@type": "Question",
                "name": "¿Cuántas calorías tiene un huevo frito?",
                "acceptedAnswer": {
                    "@type": "Answer",
                    "text": "Entre 110 y 160 kcal según el aceite. Con una cucharadita en sartén antiadherente se queda en 110-120; frito en aceite abundante absorbe 7-10 g y llega a 130-160."
                }
            },
            {
                "@type": "Question",
                "name": "¿Cuántos huevos puedo comer al día?",
                "acceptedAnswer": {
                    "@type": "Answer",
                    "text": "Para una persona sana, uno o dos al día encajan en cualquier dieta equilibrada. Quien tenga colesterol alto, diabetes o alguna condición cardiovascular debería consultarlo con su médico."
                }
            },
            {
                "@type": "Question",
                "name": "¿Es mejor comer solo claras?",
                "acceptedAnswer": {
                    "@type": "Answer",
                    "text": "Solo si necesitas mucha proteína con muy pocas calorías. La yema aporta el 55 % de la proteína del huevo y prácticamente todos los micronutrientes, así que descartarla por rutina es mal negocio."
                }
            },
            {
                "@type": "Question",
                "name": "¿Cuántas calorías tiene una tortilla francesa?",
                "acceptedAnswer": {
                    "@type": "Answer",
                    "text": "Una de dos huevos con una cucharada de aceite ronda las 230-260 kcal. En sartén antiadherente con muy poco aceite baja a 160-180."
                }
            }
        ]
    },
    seoTitle: "¿Cuántas Calorías Tiene un Huevo? 72 kcal (Tabla Completa)",
    author: "Wayo Nutrition Team",
    date: "2026-01-27",
    readTime: "7 min",
    category: "Nutrición",
    image: "https://images.unsplash.com/photo-1582169296194-e4d644c48063?w=1200",
    excerpt: "¿Cuántas calorías tiene un huevo hervido, frito, revuelto o pochado? Comparamos todas las formas de preparación y revelamos cuál es la mejor para perder peso.",
    metaDescription: "Un huevo mediano son 72 kcal. Tabla completa por preparación (cocido, frito, revuelto, tortilla), por talla S/M/L/XL y clara frente a yema.",
    keywords: ["calorías huevo", "huevo hervido calorías", "huevo frito calorías", "clara de huevo", "cuántas calorías huevo"],
    tags: ["huevo", "proteína", "calorías", "recetas"],
    content: `
      <div class="blog-article-extended">
        <p class="lead"><strong>Un huevo mediano tiene unas 72 calorías.</strong> Pero eso es el huevo solo. Frito en aceite abundante se va a 130-160, y una tortilla francesa de dos huevos ronda las 250. La preparación cambia el número más que el huevo.</p>

        <h2>Calorías del huevo según cómo lo cocines</h2>

        <p>Todo lo de esta tabla parte de <strong>un huevo mediano (M) de unos 51 g de parte comestible</strong>, que es el que se vende más en España:</p>

        <table class="comparison-table">
          <thead>
            <tr><th>Preparación</th><th>Calorías</th><th>Grasa añadida</th></tr>
          </thead>
          <tbody>
            <tr><td><strong>Cocido / duro</strong></td><td>72 kcal</td><td>Ninguna</td></tr>
            <tr><td><strong>Pasado por agua</strong></td><td>72 kcal</td><td>Ninguna</td></tr>
            <tr><td><strong>Escalfado (pochado)</strong></td><td>72 kcal</td><td>Ninguna</td></tr>
            <tr><td><strong>A la plancha, sartén antiadherente</strong></td><td>75-80 kcal</td><td>Casi ninguna</td></tr>
            <tr><td><strong>Revuelto sin nada</strong></td><td>75 kcal</td><td>Ninguna</td></tr>
            <tr><td><strong>Revuelto con mantequilla y leche</strong></td><td>110-140 kcal</td><td>1 nuez de mantequilla</td></tr>
            <tr><td><strong>Frito en una cucharadita de aceite</strong></td><td>110-120 kcal</td><td>~4-5 g</td></tr>
            <tr><td><strong>Frito español, aceite abundante</strong></td><td>130-160 kcal</td><td>~7-10 g absorbidos</td></tr>
            <tr><td><strong>Tortilla francesa de 2 huevos</strong></td><td>230-260 kcal</td><td>1 cucharada de aceite</td></tr>
          </tbody>
        </table>

        <div class="info-box">
          <h3>La regla que te ahorra la tabla</h3>
          <p>El huevo en sí siempre son ~72 kcal. <strong>Todo lo que suba de ahí es grasa que has añadido tú.</strong> Cada gramo de aceite o mantequilla son 9 kcal, y una cucharada sopera de aceite son 90.</p>
          <p>Si te sale la cuenta muy alta, el problema nunca es el huevo.</p>
        </div>

        <h2>Según el tamaño del huevo</h2>

        <p>En España los huevos se clasifican por peso con cáscara, y la diferencia entre un S y un XL es de casi 35 kcal. No es despreciable si comes tres al día:</p>

        <table class="comparison-table">
          <thead>
            <tr><th>Talla</th><th>Peso con cáscara</th><th>Parte comestible</th><th>Calorías</th></tr>
          </thead>
          <tbody>
            <tr><td><strong>S (pequeño)</strong></td><td>menos de 53 g</td><td>~44 g</td><td>~62 kcal</td></tr>
            <tr><td><strong>M (mediano)</strong></td><td>53-63 g</td><td>~51 g</td><td>~72 kcal</td></tr>
            <tr><td><strong>L (grande)</strong></td><td>63-73 g</td><td>~60 g</td><td>~84 kcal</td></tr>
            <tr><td><strong>XL (súper grande)</strong></td><td>más de 73 g</td><td>~68 g</td><td>~95 kcal</td></tr>
          </tbody>
        </table>

        <h2>Clara y yema por separado</h2>

        <table class="comparison-table">
          <thead>
            <tr><th></th><th>Calorías</th><th>Proteína</th><th>Grasa</th></tr>
          </thead>
          <tbody>
            <tr><td><strong>Huevo entero (M)</strong></td><td>72 kcal</td><td>6,3 g</td><td>4,8 g</td></tr>
            <tr><td><strong>Solo la clara</strong></td><td>17 kcal</td><td>3,6 g</td><td>0 g</td></tr>
            <tr><td><strong>Solo la yema</strong></td><td>55 kcal</td><td>2,7 g</td><td>4,5 g</td></tr>
          </tbody>
        </table>

        <p>Es decir: la yema es el 76 % de las calorías y el 100 % de la grasa, pero también el 100 % de las vitaminas A, D, E, K, del hierro, del selenio y de la colina. <strong>Tirar la yema es tirar casi todo lo interesante del huevo para ahorrar 55 kcal.</strong></p>

        <p>Tiene sentido en un solo caso: cuando necesitas mucha proteína con muy poca energía y ya has hecho la cuenta. Cuatro claras dan 14 g de proteína por 68 kcal, algo que ningún alimento entero consigue. Para todo lo demás, come el huevo entero.</p>

        <h2>¿Y el colesterol?</h2>

        <p>Un huevo tiene unos 186 mg de colesterol, todos en la yema, y durante décadas eso bastó para limitarlos a "uno o dos por semana".</p>

        <p>Ya no. Las guías alimentarias retiraron el límite numérico de colesterol dietético porque la evidencia mostró que, en la mayoría de la gente, <strong>el colesterol que comes influye poco en el que tienes en sangre</strong>: lo que más lo mueve son las grasas saturadas y trans y el patrón general de la dieta. Hay una minoría de personas hiperrespondedoras, y quien tenga colesterol alto o diabetes debería consultarlo con su médico en vez de con un artículo.</p>

        <p>En términos prácticos: un huevo al día no es un problema para una persona sana. Y ojo con el detalle que casi siempre se pasa por alto: <strong>el problema del desayuno inglés no son los huevos, es el bacon.</strong></p>

        <h2>Por qué el huevo sacia tanto</h2>

        <p>Por 72 kcal metes 6,3 g de proteína de la mejor calidad que existe: el huevo es el patrón contra el que se mide la proteína del resto de alimentos. Eso, más la grasa de la yema, hace que vacíe el estómago despacio.</p>

        <div class="example-box">
          <p><strong>Compara dos desayunos de ~300 kcal:</strong></p>
          <p>Dos huevos revueltos con una tostada integral: 300 kcal, <strong>16 g de proteína</strong>. Aguantas hasta la comida.</p>
          <p>Un bol de cereales con leche: 300 kcal, <strong>8 g de proteína</strong> y azúcar rápido. A las dos horas tienes hambre.</p>
          <p>Mismas calorías, resultado completamente distinto en cómo llega el día.</p>
        </div>

        <h2>Preguntas frecuentes</h2>

        <div class="faq-section">
          <h3>¿Cuántas calorías tiene un huevo?</h3>
          <p>Unas 72 kcal si es mediano (M) y está cocido, escalfado o pasado por agua. Un huevo L son ~84 kcal y uno XL ~95. La preparación puede duplicar esa cifra.</p>

          <h3>¿Cuántas calorías tiene un huevo frito?</h3>
          <p>Entre 110 y 160 kcal según el aceite. Con una cucharadita en sartén antiadherente se queda en 110-120; frito a la española en aceite abundante absorbe 7-10 g y se va a 130-160.</p>

          <h3>¿Cuántos huevos puedo comer al día?</h3>
          <p>Para una persona sana, uno o dos al día encajan sin problema en cualquier dieta equilibrada, y hay quien come más sin efectos adversos. Si tienes colesterol alto, diabetes o alguna condición cardiovascular, pregúntalo a tu médico.</p>

          <h3>¿Engorda el huevo?</h3>
          <p>No engorda ni adelgaza ningún alimento por sí solo: lo hace el total de tu día. Con 72 kcal y 6,3 g de proteína, el huevo es de los alimentos que mejor encajan en un déficit, porque sacia mucho por muy poco.</p>

          <h3>¿Es mejor comer solo claras?</h3>
          <p>Solo si necesitas exprimir proteína con muy pocas calorías. La yema tiene el 55 % de la proteína total del huevo y prácticamente todos los micronutrientes, así que tirarla por rutina es mal negocio.</p>

          <h3>¿Cuántas calorías tiene una tortilla francesa?</h3>
          <p>Una de dos huevos hecha con una cucharada de aceite ronda las 230-260 kcal. Si la haces en sartén antiadherente con muy poco aceite, baja a 160-180.</p>
        </div>

        <div class="key-takeaways">
          <h3>Lo que hay que recordar</h3>
          <ul>
            <li><strong>Huevo M cocido = 72 kcal.</strong> Ese es el punto de partida siempre.</li>
            <li><strong>Todo lo que suba de ahí lo has añadido tú</strong> en forma de aceite o mantequilla.</li>
            <li><strong>Cocido, escalfado o a la plancha</strong> no suman nada; frito puede duplicar.</li>
            <li><strong>La yema son 55 de las 72 kcal</strong> pero también casi todos los micronutrientes.</li>
            <li><strong>El límite de colesterol dietético se retiró:</strong> un huevo al día no es un problema para una persona sana.</li>
          </ul>
        </div>

        <div class="cta-box">
          <h3>El aceite de la sartén no se ve en la foto, pero cuenta</h3>
          <p>Es justo lo que se escapa al apuntar a mano. Con <strong>Wayo</strong> haces una foto al plato y te da calorías y macros en segundos, sin buscar "huevo frito" en ninguna lista.</p>
          <p><a href="https://wayoai.app/download" class="cta-button">Probar Wayo</a></p>
        </div>

        <div class="related-articles">
          <h3>Sigue leyendo</h3>
          <ul>
            <li><a href="/blog/alimentos-ricos-proteina-lista-completa">50 alimentos ricos en proteína</a></li>
            <li><a href="/blog/desayunos-saludables-para-bajar-de-peso">Desayunos saludables para bajar de peso</a></li>
            <li><a href="/blog/cuanta-proteina-necesito-al-dia">Cuánta proteína necesitas al día</a></li>
            <li><a href="/blog/alimentos-bajos-calorias-perder-peso">50 alimentos bajos en calorías que sacian</a></li>
          </ul>
        </div>
      </div>
    `
  }
];
